export function getCookie(name: string): string | null {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) {
		return parts.pop()?.split(";").shift() || null;
	}
	return null;
}

export function setCookie(name: string, value: string, days: number = 30) {
	const expires = new Date();
	expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
	document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

export function removeCookie(name: string) {
	document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
}

export function getStoredValue(key: string): string | null {
	return localStorage.getItem(key);
}

export function setStoredValue(key: string, value: string | null) {
	if (value) {
		localStorage.setItem(key, value);
	} else {
		localStorage.removeItem(key);
	}
}

export function getStoredJSON<T>(key: string): T | null {
	const value = localStorage.getItem(key);
	return value ? JSON.parse(value) : null;
}

export function setStoredJSON<T>(key: string, value: T | null) {
	if (value) {
		localStorage.setItem(key, JSON.stringify(value));
	} else {
		localStorage.removeItem(key);
	}
}
